// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import {
	Breadcrumb,
	Button,
	Card,
	Col,
	Offcanvas,
	Row,
	Tab
} from 'react-bootstrap';

// import custom components
import OffcanvasAddBulletinpaieForm from '../add-new-bulletinpaie/OffcanvasAddBulletinpaieForm';

// import sub components
import BulletinpaieListItems from './BulletinpaieListItems';
import BulletinpaieService from '../../services/BulletinpaieService';

const Bulletinpaie = () => {
	const [bulletinpaies, setBulletinpaies] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		BulletinpaieService.getAllBulletinpaies().then((response) => {
			setBulletinpaies(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Bulletins de paie{' '}
									<span className="fs-5 text-muted">
										{' '}
										({bulletinpaies.length})
									</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Salaires</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">
								<div>
									<Button onClick={handleShow}>
										Ajouter un bulletin de paie
									</Button>
									<Offcanvas
										show={show}
										onHide={handleClose}
										placement="end"
										name="end"
										style={{ width: '600px' }}
									>
										<Offcanvas.Header closeButton>
											<Offcanvas.Title as="h3">
												Enregistrer un bulletin de paie
											</Offcanvas.Title>
										</Offcanvas.Header>
										<Offcanvas.Body className="pt-0">
											<OffcanvasAddBulletinpaieForm onClick={handleClose} />
										</Offcanvas.Body>
									</Offcanvas>
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								<BulletinpaieListItems />
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Bulletinpaie;
